module.exports = __webpack_public_path__ + "static/media/spinner.73c90b6b.svg";